import React from 'react';

const ArrowDownIcon = ({ ...rest }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="23" viewBox="0 0 22 23" fill="none" stroke="#909195" {...rest}>
      <path d="M15 10.6475L11 14.6475L7 10.6475" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ArrowDownIcon;